<div>
  <p [innerHtml]="data.text"></p>
</div>
@if (subscribed()) {
  <div class="mt-4">
    <p-message
      [icon]="PrimeIcons.CHECK_CIRCLE"
      severity="success"
      class="w-full"
    >
      You will receive an email notification as soon as the feature is
      available.
    </p-message>
  </div>
}
<div class="flex items-center justify-end gap-2 mt-4">
  <p-button severity="secondary" (click)="close()" type="button">
    Close
  </p-button>
  @if (!subscribed()) {
    <button
      pButton
      severity="contrast"
      (click)="subscribeToUpdate()"
      [pAutoFocus]="true"
    >
      <i pButtonIcon class="{{ PrimeIcons.BELL }}"></i>
      <span pButtonLabel>Notify me!</span>
    </button>
  }
</div>
